import { makeStyles } from '@material-ui/core';

const styles = makeStyles(() => ({
  displayValue: {
    textTransform: 'initial',
  },
}));

export default styles;
